import axiosInstance from '../api/axiosInstance';

export interface DashboardData {
  totalProducts: number;
  totalBranches: number;
  totalPublishedProducts: number;
  totalWidgetUsers: number;
  totalOnlineWidgetUsers: number;
}

export interface ShowroomScheduleItem {
  id: string;
  // New API fields
  bookedTime?: string;
  name: string | null;
  date: string | null;
  time: string | null;
  customerName: string | null;
  contactInfo: string | null;
  bookingType: string;
  createdAt: string;
  updatedAt: string;
  roomPhoto: string | null;
  preferredSize?: string | null;
  preferredColor?: string | string[] | null;
  style?: string | null;
  roomType?: string | null;
  hasPets?: boolean;
  hasChildren?: boolean;
  branch: {
    id: string;
    name: string;
    address?: string;
    phoneNumber?: string;
    imageUrls?: string[];
    isActive?: boolean;
    createdAt?: string;
    updatedAt?: string;
  };
  scheduleProducts?: {
    id: string;
    createdAt: string;
    product: {
      id: string;
      name: string;
      sku: string;
      product_url: string;
      warranty: string | null;
      roomTypes: string[];
      description: string | null;
      type: string;
      createdAt: string;
      updatedAt: string;
      origin?: string;
      isSynced?: boolean;
      images: {
        id: string;
        originalUrl?: string;
        thumbnailUrl?: string;
        url?: string;
        sortOrder?: number;
        isPrimary?: boolean;
        createdAt?: string;
        updatedAt?: string;
      }[];
      attributes: unknown[];
    };
  }[];
  widgetUser: {
    id: string;
    firstName: string | null;
    lastName: string | null;
    contact: string | null;
    memory?: {
      query?: string;
      interested_product_id?: string[];
      // keep open for future fields
      [key: string]: unknown;
    } | null;
    sessionId?: string;
    createdAt?: string;
    updatedAt?: string;
    lastImageUrl?: string | null;
  };
}

export interface ShowroomScheduleResponse {
  data: ShowroomScheduleItem[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const dashboardAPI = {
  getDashboardData: async (): Promise<DashboardData> => {
    const response = await axiosInstance.get<DashboardData>(
      '/companies/getDashboard'
    );
    return response.data;
  },
  getScheduleData: async (
    branchId: string,
    params: { page?: number; limit?: number } = {}
  ): Promise<ShowroomScheduleResponse> => {
    const response = await axiosInstance.get<ShowroomScheduleResponse>(
      `/branches/${branchId}/schedules`,
      { params }
    );
    return response.data;
  },
};
